import { CommonModule } from '@angular/common';
import { Component, Inject, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { DateFnsModule } from 'ngx-date-fns';
import { Observable } from 'rxjs';

import { DialogModule } from '../dialog';
import { ButtonModule } from './../button/button.module';

export type IdleDialogData = {
  heading?: string;
  contentString?: string;
  contentTemplate?: TemplateRef<unknown>;
  contentTemplateContext?: unknown;
  buttonLabel?: string;
  timeRemaining$: Observable<Date>;
};

const INACTIVITY_DIALOG_DATA = {
  header: $localize`Inactivity warning!`,
  content: $localize`Are you still there? If not your session will be ended shortly`,
  buttonText: $localize`Continue working`,
};

@Component({
    selector: 'lui-idle-dialog',
    imports: [
        CommonModule,
        DialogModule,
        MatDialogModule,
        ButtonModule,
        DateFnsModule,
    ],
    templateUrl: './idle-dialog.component.html',
    styleUrls: ['./idle-dialog.component.scss']
})
export class IdleDialogComponent {
  protected heading = '';
  protected contentString = '';
  protected contentTemplate: TemplateRef<unknown> | undefined;
  protected contentTemplateContext: unknown;
  protected buttonLabel = '';

  constructor(@Inject(MAT_DIALOG_DATA) data: IdleDialogData) {
    const dialogConstants = INACTIVITY_DIALOG_DATA;
    if (data) {
      this.heading = data.heading || dialogConstants.header;
      this.contentString = data.contentString || dialogConstants.content;
      this.contentTemplate = data.contentTemplate;
      this.buttonLabel = data.buttonLabel || dialogConstants.buttonText;
      this.contentTemplateContext = data.contentTemplateContext;
    }
  }
}
